import { render } from "./prompt-packs.vue?vue&type=template&id=57584076&lang=pug"
import script from "./prompt-packs.vue?vue&type=script&lang=js"
export * from "./prompt-packs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__